if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let form_id_3711 = document.querySelector( "#form_id-3703 #form_id-3703-yes-signup-formemail-signup" );
    if( form_id_3711 ){
        form_id_3711.classList.add( "required" )
        form_id_3711.checked = true
        form_id_3711.parentElement.classList.add( "hidden" )
    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	// WRAP MODULE TABLES
	document.querySelectorAll('.tableModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});



    // Accordion
    let allAccordionArticles = document.getElementsByClassName('js-accordion-item');
    let allAccordionItems = document.getElementsByClassName('js-accordion-title');
    let allALength = allAccordionItems.length;

    for(let i =0; i < allALength; i++){
        allAccordionItems[0].click();
        allAccordionItems[i].addEventListener('click', function(){
            let currentParent = this.parentElement;
            let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
            let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];

            let images = document.querySelectorAll( ".entry-image" );
            let images_total = images.length;
            let ref = this.dataset.ref;

            for( let j = 0 ; j < images_total ; j++ ){
                images[j].classList.add( "hidden" );
            }

            document.querySelector( ".id_" + ref ).classList.remove( "hidden" );

            if(currentParent.classList.contains('open')){
                currentParent.classList.remove('open');
                currentCopy.style.height = '0';
            } else {
                for(let j =0; j < allALength; j++){
                    allAccordionItems[j].parentElement.classList.remove('open');

                    let currentCopyToCLose = allAccordionItems[j].parentElement.getElementsByClassName('js-accordion-copy')[0];
                    currentCopyToCLose.style.height = '0';
                }

                currentParent.classList.add('open');
                currentCopy.style.height = currentCopyHeight + 'px';
                
            }
        })
    }

	 // CUSTOM SELECT
	 document.querySelectorAll('[data-custom_select]').forEach((select) => {
        const currentField = select.querySelector('input');

        if (currentField) {
            currentField.addEventListener('click', () =>
                select.classList.toggle('active')
            );
        }

        select.querySelectorAll('li').forEach((li) => {
            li.addEventListener('click', () => {
                if (currentField) {
                    currentField.value = li.dataset.value;
                }

                select
                    .querySelectorAll('li')
                    .forEach((l) => l.classList.remove('active'));
                li.classList.add('active');

                select.classList.remove('active');
            });
        });
    });


	// MOBILE TABLE TO DROPDOWNS
	const tablesResp = document.querySelectorAll('.tableModule table');
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.responsive_slides').slick({
        accessibility: false,
        slidesToShow: 2,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
            },
            {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
        ]
    });

     $('.offers-slides').slick({
        slidesToShow: 3,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
            },
            {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
        ]
    });

	$('[data-fancybox]').fancybox({
		infobar  : false,
		loop: true
    })

    $(document).ready(function() {
        // Inhabilitar el scroll cuando se muestra el lightbox
        $("[data-fancybox]").fancybox({
          beforeShow: function() {
            $("body").css("overflow", "hidden");
          },
          afterClose: function() {
            $("body").css("overflow", "auto");
          }
        });
      });
   
    // FANCYBOX SETTINGS
	$.fancybox.defaults.backFocus = false;
	$.fancybox.defaults.autoFocus = false;
	$.fancybox.defaults.touch = false;
	$.fancybox.defaults.smallBtn = true;
	$.fancybox.defaults.btnTpl.smallBtn = `<button class="fancybox-button fancybox-close-small" title="{{CLOSE}}" type="button" data-fancybox-close><svg fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowLeft = `<button class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" type="button" data-fancybox-prev><span>Prev</span><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18"><g><g><path fill="#ffffff" d="M1.615 8.327L8.802.805a.511.511 0 0 0-.024-.699.519.519 0 0 0-.71.023L.089 8.48v.001a.522.522 0 0 0 0 .676l7.98 8.35c.21.204.518.2.71.023a.508.508 0 0 0 .024-.699L1.615 9.31z"/></g></g></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `<button class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" type="button" data-fancybox-next><span>Next</span><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18"><g><g><path fill="#ffffff" d="M1.615 8.327L8.802.805a.511.511 0 0 0-.024-.699.519.519 0 0 0-.71.023L.089 8.48v.001a.522.522 0 0 0 0 .676l7.98 8.35c.21.204.518.2.71.023a.508.508 0 0 0 .024-.699L1.615 9.31z"/></g></g></svg></button>`;
    $.fancybox.defaults.clickOutside = false;



    $('[data-slick_prev]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('[data-slick_next]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});

	$('[data-slick-goto]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		const target = $(this).data('slick-goto') ? parseInt($(this).data('slick-goto')) : 0;

		$curSlider.slick('slickGoTo', target);
		$(this).siblings('[data-slick-goto]').removeClass('active');
		$(this).addClass('active');
	});



})();